module.exports = __webpack_public_path__ + "7838cfc2.svg";